<div class="page-container">
  <div class="page-content">
    @if(call$ | async; as call) { @if(templateItems$ | async; as templateItems) { @let customDocuments = customDocuments$ | async; @if (call.isSuccess &&
    templateItems.isSuccess && customDocuments !== null) {
    <div>
      <div class="page-header">
        <div class="header-left">
          <div class="back-button-container">
            <button mat-icon-button (click)="goBackToCall(call.data.id)">
              <mat-icon>chevron_left</mat-icon>
            </button>
          </div>
          <div class="call-info">
            <div class="call-name">{{ call.data.name }}</div>
            <div class="call-details">
              {{ call.data.date | date: 'd MMM y' }} · {{ call.data.date | date: 'HH:mm' }} @if (call.data.duration !== null) { · {{ call.data.duration |
              duration }} }
            </div>
          </div>
        </div>
        <div class="header-actions">
          @if(templateModels$ | async; as templates) { @if (templates.isSuccess) {
          <button mat-stroked-button (click)="importTemplate(templates.data)">
            <mat-icon>file_download</mat-icon>
            {{ 'TEMPLATES.IMPORT_TEMPLATE' | translate }}
          </button>
          } }
          <button mat-stroked-button (click)="saveAsTemplate()">
            <mat-icon>save</mat-icon>
            {{ 'TEMPLATES.SAVE_AS_TEMPLATE' | translate }}
          </button>
        </div>
      </div>
      <app-template-editor
        #templateEditor
        [templateItems]="templateItems.data"
        [availableResources]="customDocuments"
        [allowFileUpload]="true"
        [attendeeNames]="call.data.attendeeNames"
        [superModeEnabled]="true"
        [isFullscreenModeEnabled]="true"
        (templateSaved)="saveTemplate($event)"
        (fileUploadRequested)="handleFileUpload($event, call.data.id)"
        (templateItemsChanged)="onTemplateItemsChanged($event)"
        (exitFullscreenRequested)="goBackToCall(call.data.id)"
      />
    </div>
    <div class="sidebar-content">
      @if (liveTemplateItems$ | async; as liveItems) {
      <app-template-preview-panel [templateItems]="liveItems" (itemClicked)="onPreviewItemClicked($event)"> </app-template-preview-panel>
      }
      <div class="file-upload-section">
        <h3>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.TITLE' | translate }}</h3>
        @if(customDocuments.length > 0) {
        <div class="uploaded-documents-list">
          @for (resource of customDocuments; track resource.index) {
          <div class="uploaded-document">
            <mat-icon class="clickable" (click)="openPdfPreview(resource)">description</mat-icon>
            <div class="details clickable" [matTooltip]="resource.fileName" (click)="openPdfPreview(resource)">
              <div class="file-name">{{ truncateFileNameFromMiddle(resource.fileName, 50) }}</div>
              <div class="file-metadata">
                @if (resource.metadata !== null) { {{ resource.metadata.numberOfPages | pageCount }} · } {{ resource.size | filesize: {round: 0} }}
              </div>
            </div>
            <mat-icon class="clickable" color="warn" (click)="removeDocument(resource)" [matTooltip]="'COMMON.REMOVE' | translate">delete</mat-icon>
          </div>
          }
        </div>
        }
        <app-multi-file-upload [acceptedFileTypes]="['pdf']" [maxSize]="maximumCustomDocumentSize" [callId]="call.data.id"> </app-multi-file-upload>
      </div>
    </div>
    }}}
  </div>
</div>
